import UploaderModel from "./UploaderModel";
import UploaderView from "./UploaderView";
import ImageFileView from "./ImageFileView";
import UploaderClass from "./Uploader";
import UploadAdapter from "./UploadAdapter";
import SpinnerView from "./SpinnerView";
import FileModel, {FileStates} from "./FileModel";
import ImageModel from "./ImageModel";
import FileView from "./FileView";
import BasicAdapter from "./BasicAdapter";
import ErrorView from "./ErrorView";
import AddButton from "./AddButton";
import EmptyView from "./EmptyView";
import InvalidFileModel from "./InvalidFileModel";
import ItemView from "./ItemView";
import PlaceholderView from "./PlaceholderView";

const Uploader = {
  Uploader: UploaderClass,
  UploaderModel,
  UploaderView,
  FileModel,
  ImageModel,
  ItemView,
  FileView,
  ImageFileView,
  UploadAdapter,
  BasicAdapter,
  SpinnerView,
  ErrorView,
  AddButton,
  EmptyView,
  PlaceholderView,
  InvalidFileModel,
  FileStates
};

export default Uploader;
